<template>
    <div class="fullscreen-box">
        <div class="fullscreen-box--outer">
            <div class="fullscreen-box--inner">
                <div class="fullscreen-box--container">
                    <div class="fullscreen-box--content">
                        <transition name="fadeInUp">
                            <remind-password-form v-if="view == 1" :view="view"></remind-password-form>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RemindPasswordForm from './partials/RemindPasswordForm.vue'

    export default {
        components: { RemindPasswordForm },
        computed: {
            view () {
                return this.$store.getters.loginForm.view
            }
        },
        methods: {
            changeView (view) {
                this.$store.commit('loginFormView', 2)
                setTimeout(() => {
                    this.$store.commit('loginFormView', view)
                }, 600)
            },
        },
        beforeCreate () {
            this.$store.commit('loginFormView', 2)
        },
        mounted () {
            this.changeView(1)
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_colors.scss';
    @import '../../assets/scss/_guest.scss';
    @import '../../assets/css/transitions.css';

    .fullscreen-box{
        background-image: url('../../assets/img/ftn-home-bg.jpg');
    }
</style>


// WEBPACK FOOTER //
// src/components/remind-password/RemindPassword.vue